import { request } from '@/common/request';

// 医生列表
export const getDoctorList = (params: any) => {
  return request.post<any, any>('/doctor/page', params);
};
// 医生详情
export const getDoctorInfo = (id: string) => {
  return request.post<any, any>('/doctor/info', { id });
};
// 医生详情
export const checkUserName = (params: any) => {
  return request.post<any, any>('/doctor/getUserName', params);
};
// 创建医生
export const addDoctor = (params: any) => {
  return request.post<any, any>('/doctor/add', params);
};
// 编辑医生
export const updateDoctor = (params: any) => {
  return request.post<any, any>('/doctor/update', params);
};
// 禁用/启用医生
export const updateDoctorStatus = (params: any) => {
  return request.post<any, any>('/doctor/updateUserStatus', params);
};
// 解绑医生微信
export const unbind = (openId: string) => {
  return request.post<any, any>('/doctor/unbind', { openId });
};
// 获取医生账号登录信息
export const getDoctorAccount = (params: any) => {
  const url = '/agency/getUser';
  return request.post<any, any>(url, params);
};
// 更新医生账号登录信息
export const updateDoctorAccount = (params: any) => {
  const url = '/agency/updateUser';
  return request.post<any, any>(url, params);
};
// 医生概览
export const getSubscribeNumber = (params: any) => {
  const url = '/doctor/subscribeNumber';
  return request.post<any, any>(url, params);
};

// 医生信息搜索
export const getDoctorDatabasePage = (params: any) => {
  const url = '/doctor/database/page';
  return request.post<any, any>(url, params);
};
// 医生详细信息
export const getDoctorInfoDetail = (params: any) => {
  const url = '/doctor/database/query';
  return request.post<any, any>(url, params);
};
// 医生详情
export const getDoctorDetail = (id: string) => {
  return request.post<any, any>('/doctor/detail', { id });
};

// 保存医生
export const saveDoctor = (params: any) => {
  return request.post<any, any>('/doctor/save', params);
};

/** 推送账户信息  */
export const pushAccountInfo = (params: any) => {
  return request.post<any, any>('/doctor/pushAccountInfo', params);
};

/** 医生用户列表  */
export const httpDoctorUserPage = (params: any) => {
  return request.post<any, any>('/doctor/user/page', params);
};

/** 工作微应用-运营分析-操作  */
export const httpWorkWechatDashboardOperate = (params: any) => {
  return request.get<any, any>('/work-wechat/dashboard/operate', params);
};

/** 医生用户详情  */
export const httpDoctorUserDetail = (params: any) => {
  return request.post<any, any>('/doctor/user/detail', params);
};

/** 新增医生数据库  */
export const httpAddDoctorDatabase = (params: any) => {
  return request.post<any, any>('/doctor/database/add', params);
};

/** 校验手机号是否已注册  */
export const httpValidatePhone = (params: any) => {
  return request.post<any, any>('/doctor/phone/validate', params);
};

/** 校验医生是否完成信息登记填写 */
export const httpValidateCompleted = (params: any) => {
  return request.post<any, any>('/doctor/info/validateCompleted', params);
};

/** 新增医生用户  */
export const httpJoinDoctorUser = (params: any) => {
  return request.post<any, any>('/doctor/project/join', params);
};

export default {};
